module.exports = __webpack_public_path__ + "media/images/badges/clubpilates-badge-1c8aa9f356cbab2458745d767f910e24.svg";